var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#EEF8F4",
    stroke: "#93C2A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.381 17H9.118V7.965H12.381C14.032 7.965 15.449 8.615 16.333 10.006C16.775 10.708 16.996 11.54 16.996 12.489C16.996 13.893 16.554 14.998 15.657 15.791C14.76 16.597 13.668 17 12.381 17ZM10.223 8.94V16.025H12.173C14.097 16.025 15.839 15.063 15.839 12.476C15.839 11.267 15.488 10.37 14.799 9.798C14.11 9.226 13.226 8.94 12.173 8.94H10.223Z",
    fill: "#7CB58E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterD);
export default __webpack_public_path__ + "static/media/letterD.21f4133b91e8409cfe7a6acbdf632924.svg";
export { ForwardRef as ReactComponent };